export const VUE_APP_API_FLOWS_BASE_URL="https://plrq95k4jc.execute-api.us-west-2.amazonaws.com/dev";
export const VUE_APP_API_CAMPAINGS_BASE_URL="https://mklzompzkj.execute-api.us-west-2.amazonaws.com/dev";
export const VUE_APP_API_INBOXES_BASE_URL="https://4anmc5pq9h.execute-api.us-west-2.amazonaws.com/dev";
//export const VUE_APP_API_TYPEBOT_BASE_URL="https://fchat-tyb-demo-internal.flexi.cx"
export const VUE_APP_API_TYPEBOT_BASE_URL="https://fchat-tyb-demo-internal.flexi.cx/"
export const METABASE_SITE_URL = "https://fchat-mb.flexi.cx";
export const METABASE_SECRET_KEY = "e7eba4944eb47787cd95f21cad090cc5c703c40db342de327f55e95dc10eed3c"; // Ensure this is a valid string
export const METABASE_DASHBOARD_CONTACTS = 1; // Replace with actual dashboard ID
export const METABASE_DASHBOARD_CONVERSATIONS = 2; 
export const VUE_APP_API_AI_AGENTS_BASE_URL="https://mklzompzkj.execute-api.us-west-2.amazonaws.com/dev";
export const METABASE_DASHBOARD_BILLING = 6;
export const METABASE_NOTIFAI_SITE_URL = "https://mb1.notifai.pe";
export const METABASE_NOTIFAI_SECRET_KEY = "9ea90404c2d175e2d4811f3da2016a98a58872fb7ec38c0a1c88cfaf623e0758";
export const METABASE_DASHBOARD_LAIVE = 56;
